const SubAbasArps = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/proaq/arps/${id}/dadosgerais`,
  },
  {
    label: 'Destaques',
    rota: `/daf/proaq/arps/${id}/destaques`,
  },
];

export default SubAbasArps;
